<ng-container *ngIf="subscription$ | async as subscription; else signup">
  <button
    type="button"
    mat-raised-button
    color="primary"
    (click)="redirectToManagementPortal()"
  >
    Gérer mon abonnement Premium
  </button>
</ng-container>

<ng-template #signup>
  <button type="button" mat-raised-button color="accent" (click)="subscribe()">
    Adhérer à Premium
  </button>
</ng-template>
